<script>
import InputEmitButton from './InputEmitButton.vue'
import FileInputControl from '../FileInputControl.vue';
import VueSelect from 'vue-select';

export default {
    components: {
        InputEmitButton,
        FileInputControl,
        VueSelect,
    },

    props: {
        personSpecification: {
            type: Object,
            required: true
        },
        twoColumn: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        },
        inputsClickable: {
            type: Boolean,
            default: false
        },
        expand: {
            type: Boolean,
            default: false
        },
        questionsClass: {
            type: String,
            default: 'bordered'
        },
        readonlyGridPosition: {
            type: String,
            default: 'items-center'
        }
    },

    data() {
        return {
            expanded: this.expand
        }
    },

    methods: {
        removePTag(str) {
            if (typeof str === 'number') {
                return str;
            }
            if (typeof str !== 'string' || str === null || str === undefined) {
                return '';
            }
            return str.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },
    },

    computed: {
        essentialKnowledgeCompetencies() {
            return this.personSpecification.essential_knowledge_competencies.map(comp => comp.title);
        },
        prefentialKnowledgeCompetencies() {
            return this.personSpecification.preferred_knowledge_competencies.map(comp => comp.title);
        },
        essentialExperienceCompetencies() {
            return this.personSpecification.essential_experience_competencies.map(comp => comp.title);
        },
        prefentialExperienceCompetencies() {
            return this.personSpecification.preferred_experience_competencies.map(comp => comp.title);
        },
        essentialSkillCompetencies() {
            return this.personSpecification.essential_skill_competencies.map(comp => comp.title);
        },
        prefentialSkillCompetencies() {
            return this.personSpecification.preferred_skill_competencies.map(comp => comp.title);
        },
        essentialAttributeCompencies() {
            return this.personSpecification.essential_attribute_competencies.map(comp => comp.title);
        },
        prefentialAttributeCompencies() {
            return this.personSpecification.preferred_attribute_competencies.map(comp => comp.title);
        },
    }
}
</script>

<template>
    <fieldset class="person-spec-readonly" :class="expand === true ? '' : 'bordered'">
        <button v-if="expand === false" @click.prevent="expanded = !expanded" type="button" class="button small" :class="expanded ? 'expanded' : 'collapsed'">{{ expanded ? 'Collapse' : 'Expand' }}</button>

        <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
            <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-4'">
                <label>Person Specification Title</label>

                <div class="textarea" v-html="personSpecification.title"></div>
            </div>
            <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Person Specification Title', personSpecification.title)" />
        </div>

        <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
            <div class="cell mb-12 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                <label>Purpose of Role</label>

                <div class="html-content" v-html="personSpecification.purpose"></div>
            </div>
            <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Purpose of Role', personSpecification.purpose)" />
        </div>

        <div v-if="twoColumn">
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Knowledge & Education Essential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialKnowledgeCompetencies"
                        :value="essentialKnowledgeCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Knowledge & Education Essential', personSpecification.essential_knowledge_competencies.map(comp => comp.title).join(', '))" />
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Knowledge & Education Preferential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialKnowledgeCompetencies"
                        :value="prefentialKnowledgeCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Knowledge & Education Preferential', personSpecification.preferred_knowledge_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Experience Essential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialExperienceCompetencies"
                        :value="essentialExperienceCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Experience Essential', personSpecification.essential_experience_competencies.map(comp => comp.title).join(', '))" />
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Experience Preferential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialExperienceCompetencies"
                        :value="prefentialExperienceCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Experience Preferential', personSpecification.preferred_experience_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Skills Essential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialSkillCompetencies"
                        :value="essentialSkillCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Skills Essential', personSpecification.essential_skill_competencies.map(comp => comp.title).join(', '))" />
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Skills Preferential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialSkillCompetencies"
                        :value="prefentialSkillCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Skills Preferential', personSpecification.preferred_skill_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Attributes Essential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialAttributeCompencies"
                        :value="essentialAttributeCompencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Attributes Essential', personSpecification.essential_attribute_competencies.map(comp => comp.title).join(', '))" />
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Attributes Preferential</label>
                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialAttributeCompencies"
                        :value="prefentialAttributeCompencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Attributes Preferential', personSpecification.preferred_attribute_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Shift Hours</label>

                    <div class="html-content">
                        {{ removePTag(personSpecification.shift_hours) || '&nbsp;' }}
                    </div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Shift Hours', personSpecification.shift_hours)" />
                <div class="cell mb-4 low-opacity medium-4">
                    <label>Breaks And Lunch</label>

                    <div class="html-content">
                        {{ removePTag(personSpecification.breaks_and_lunch) || '&nbsp;' }}
                    </div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Breaks And Lunch', personSpecification.breaks_and_lunch)" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Shift Service Areas</label>

                    <div class="html-content">
                        {{ personSpecification.shift_service_areas || '&nbsp;' }}
                    </div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Shift Service Areas', personSpecification.shift_service_areas)" />
            </div>
        </div>
        <div v-else>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Knowledge & Education Essential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialKnowledgeCompetencies"
                        :value="essentialKnowledgeCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Knowledge & Education Essential', personSpecification.essential_knowledge_competencies.map(comp => comp.title).join(', '))" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Knowledge & Education Preferential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialKnowledgeCompetencies"
                        :value="prefentialKnowledgeCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Knowledge & Education Preferential', personSpecification.preferred_knowledge_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Experience Essential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialExperienceCompetencies"
                        :value="essentialExperienceCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Experience Essential', personSpecification.essential_experience_competencies.map(comp => comp.title).join(', '))" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Experience Preferential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialExperienceCompetencies"
                        :value="prefentialExperienceCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Experience Preferential', personSpecification.preferred_experience_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Skills Essential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialSkillCompetencies"
                        :value="essentialSkillCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Skills Essential', personSpecification.essential_skill_competencies.map(comp => comp.title).join(', '))" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Skills Preferential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialSkillCompetencies"
                        :value="prefentialSkillCompetencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Skills Preferential', personSpecification.preferred_skill_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Attributes Essential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="essentialAttributeCompencies"
                        :value="essentialAttributeCompencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Attributes Essential', personSpecification.essential_attribute_competencies.map(comp => comp.title).join(', '))" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Attributes Preferential</label>

                    <vue-select
                        class="personspec-dropdown"
                        :disabled="true"
                        :options="prefentialAttributeCompencies"
                        :value="prefentialAttributeCompencies"
                        :multiple="true"
                    />
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Attributes Preferential', personSpecification.preferred_attribute_competencies.map(comp => comp.title).join(', '))" />
            </div>

            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Shift Hours</label>

                    <div class="html-content">
                        {{ removePTag(personSpecification.shift_hours) || '&nbsp;' }}
                    </div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Shift Hours', personSpecification.shift_hours)" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Breaks And Lunch</label>

                    <div class="html-content">
                        {{ removePTag(personSpecification.breaks_and_lunch) || '&nbsp;' }}
                    </div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Breaks And Lunch', personSpecification.breaks_and_lunch)" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Shift Service Areas</label>

                    <div class="html-content">
                        {{ removePTag(personSpecification.shift_service_areas) || '&nbsp;' }}
                    </div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Shift Service Areas', personSpecification.shift_service_areas)" />
            </div>
        </div>
        

        <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
            <div class="cell" :class="compact === true ? 'small-12' : 'medium-8 large-6'">
                <label class="mb-0 low-opacity">Employment Phases</label>
                <div v-if="!compact" class="grid-x grid-padding-x low-opacity">
                    <div class="cell small-4">
                        <label>Employment Phases:</label>
                    </div>

                    <div class="cell small-4">
                        <label>Duration:</label>
                    </div>

                    <div class="cell small-4">
                        <label>Rate:</label>
                    </div>
                </div>

                <div v-for="employmentPhase in personSpecification.employment_phase_specs" class="grid-x grid-padding-x mb-4 ml-1" :class="readonlyGridPosition">
                    <div class="cell low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                        <label class="fw-normal mb-1" v-if="compact === true">Employment Phase:</label>
                        <div class="textarea">
                            {{ removePTag(employmentPhase.title) }}
                        </div>
                    </div>
                
                    <div class="cell low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                        <label class="fw-normal mb-1" v-if="compact === true">Duration:</label>
                        <div class="textarea">
                            {{ removePTag(employmentPhase.duration) }}
                        </div>
                    </div>

                    <div class="cell low-opacity" :class="compact === true ? 'auto' : 'small-3'">
                        <label class="fw-normal mb-1" v-if="compact === true">Rate:</label>
                        <div class="textarea">
                            {{ removePTag(employmentPhase.rate)}}
                        </div>
                        <input-emit-button v-if="inputsClickable" container-class="cell" @click="() => $emit('input-clicked', 'Rate', employmentPhase.rate)" />
                    </div>
                    <input-emit-button v-if="inputsClickable" container-class="cell" @click="() => $emit('input-clicked', 'Employment Phase | Duration | Rate', employmentPhase.title + ' | ' + employmentPhase.duration + ' | ' + employmentPhase.rate)" />
                </div>
            </div>
        </div>

        <div v-show="expanded" class="grid-x grid-padding-x">
            <div class="cell" :class="compact === true ? 'small-12' : 'medium-6 large-5'">
                <label class="mb-0 low-opacity">Background Verification</label>
                <div v-if="!compact" class="grid-x grid-padding-x low-opacity">
                    <div class="cell small-4">
                        <label>Verification Type:</label>
                    </div>

                    <div class="cell small-4">
                        <label>Method:</label>
                    </div>

                    <div class="cell small-4">
                        <label>Notes:</label>
                    </div>
                </div>

                <div v-if="personSpecification.background_verification_specs">
                    <div v-for="verificationSpec in personSpecification.background_verification_specs" class="grid-x grid-padding-x mb-4 ml-1" :class="readonlyGridPosition">
                        <div class="cell pl-0 low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                            <label class="fw-normal mb-1" v-if="compact">Verification Type:</label>
                            <div class="textarea">
                                {{ removePTag(verificationSpec.title) }}
                            </div>
                        </div>

                        <div class="cell pl-0 low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                            <label class="fw-normal mb-1" v-if="compact">Method:</label>
                            <div class="textarea">
                                {{ removePTag(verificationSpec.method) }}
                            </div>
                        </div>

                        <div class="cell pl-0 low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                            <label class="fw-normal mb-1" v-if="compact">Notes:</label>
                            <div class="textarea">
                                {{ verificationSpec.method === 'ifacts' ? removePTag(verificationSpec.ifacts_check.title) : removePTag(verificationSpec.notes) }}
                            </div>
                        </div>
                        <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Verification Type | Method | Notes', verificationSpec.title + ' | ' + verificationSpec.method + ' | ' + (verificationSpec.method === 'ifacts' ? verificationSpec.ifacts_check.title : verificationSpec.notes || ''))" />
                    </div>
                </div>
            </div>
        </div>

        <div v-show="expanded" class="grid-x grid-padding-x mb-4" :class="this.readonlyGridPosition">
            <div class="cell" :class="compact === true ? 'small-12' : 'medium-6 large-5'">
                <label class="mb-0 low-opacity">Skills Assessments</label>
                <div v-if="!compact" class="grid-x grid-padding-x">
                    <div class="cell" :class="compact === true ?'small-12' : 'small-4'">
                        <label>Verification Type:</label>
                    </div>

                    <div class="cell" :class="compact === true ?'small-12' : 'small-4'">
                        <label>Method:</label>
                    </div>

                    <!-- <div class="cell" :class="compact === true ?'small-12' : 'small-2'">
                        <label>Benchmark:</label>
                    </div> -->

                    <div class="cell" :class="compact === true ?'small-12' : 'small-4'">
                        <label>Notes:</label>
                    </div>
                </div>

                <div v-if="personSpecification.skill_assessment_specs">
                    <div v-for="skillAssessmentSpec in personSpecification.skill_assessment_specs" class="grid-x grid-padding-x mb-4 ml-1" :class="readonlyGridPosition">
                        <div class="cell pl-0 low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                            <label class="fw-normal mb-1" v-if="compact">Assessment Type:</label>
                            <div class="textarea">
                                {{ removePTag(skillAssessmentSpec.title) }}
                            </div>
                        </div>

                        <div class="cell pl-0 low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                            <label class="fw-normal mb-1" v-if="compact">Method:</label>
                            <div class="textarea">
                                {{ removePTag(skillAssessmentSpec.method) }}
                            </div>
                        </div>

                            <!-- <div class="cell" :class="compact === true ? 'small-10 medium-6' : 'small-2'">
                                <label class="fw-normal mb-1">Benchmark:</label>
                                <div class="textarea">
                                    {{ skillAssessmentSpec.method === 'classmarker' ? skillAssessmentSpec.classmarker_assessment.title : skillAssessmentSpec.benchmark }}
                                </div>
                            </div>
                            <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Benchmark', skillAssessmentSpec.method === 'classmarker' ? skillAssessmentSpec.classmarker_assessment.title : skillAssessmentSpec.benchmark)" /> -->

                        <div class="cell pl-0 low-opacity" :class="compact === true ? 'auto' : 'small-4'">
                            <label class="fw-normal mb-1" v-if="compact">Notes:</label>
                            <div class="textarea">
                                {{ removePTag(skillAssessmentSpec.instructions) }}
                            </div>
                        </div>
                        <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Assessment Type | Method | Notes', skillAssessmentSpec.title + ' | ' + skillAssessmentSpec.method + ' | ' + (skillAssessmentSpec.method === 'classmarker' ? skillAssessmentSpec.classmarker_assessment.title : skillAssessmentSpec.benchmark || ''))" />
                    </div>
                </div>
            </div>
        </div>

        <div v-show="expanded" class="grid-x grid-padding-x mb-4" :class="this.readonlyGridPosition">
            <div class="cell small-12" :class="compact === true ? 'auto' : 'medium-6'">
                <fieldset v-show="expanded" v-for="(killerQuestionSpec, i) in personSpecification.killer_questions" :key="i" class="killer-question-fieldset" :class="questionsClass">
                    <label class="low-opacity">Killer Questions</label>
                    <div class="grid-x grid-padding-x" :class="readonlyGridPosition">
                        <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                            <label>Question {{ i + 1 }}:</label>

                            <div class="textarea">
                                {{ removePTag(killerQuestionSpec.title) }}
                            </div>
                        </div>
                    </div>

                    <div class="grid-x grid-padding-x low-opacity">
                        <div class="cell small-6">
                            <label>Answer:</label>
                        </div>

                        <div class="cell small-6">
                            <label>Result:</label>
                        </div>
                    </div>

                    <div v-if="killerQuestionSpec.killer_question_answers">
                        <div v-for="(answer, j) in killerQuestionSpec.killer_question_answers" :key="j" class="grid-x grid-padding-x mb-4 low-opacity">
                            <div class="cell small-6">
                                <div class="textarea">
                                    {{ removePTag(answer.title) }}
                                </div>
                            </div>
                            <div class="cell small-6">
                                <div class="textarea">
                                    {{ answer.is_correct ? 'Pass' : 'Fail'}}
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div v-show="expanded" class="grid-x grid-padding-x" :class="readonlyGridPosition">
            <div class="cell mb-4 low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                <label>Client Original Brief</label>
                <div v-if="personSpecification.client_original_brief">
                    <small>(Existing: <a target="_blank" :href="personSpecification.client_original_brief">{{ personSpecification.client_original_brief }}</a>)</small>
                
                    <FileInputControl name="client_original_brief" :disabled="true"/>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<style>

.requisition-crud .v-select, .requisition-crud .vs__dropdown-toggle {
    height: auto;
}

</style>